import React from 'react'
import { reverse } from 'named-urls'
import { useHistory } from 'react-router-dom'

import { Paper, Box } from '@material-ui/core'

import * as service from 'service'
import useFetch from 'hooks/useFetch'
import useSnackbar from 'hooks/useSnackbar'
import { routes } from 'routes'
import { Container, ContentHeader } from 'components'
import ClientAddressForm from './components/ClientAddressForm'

const ClientsEditAddress = ({ match }) => {
  const { clientId } = match.params
  const snackbar = useSnackbar()
  const { response, isLoading } = useFetch(service.recurrence.customers.get, {
    clientId,
  })
  const history = useHistory()

  const handleSubmit = async address => {
    try {
      await service.recurrence.customers.put({
        clientId,
        addressAttributes: address,
      })

      snackbar.open({
        message: 'Endereço alterado com sucesso!',
        variant: 'success',
      })

      history.push(reverse(routes.clients.show, { clientId }))
    } catch (error) {
      snackbar.open({
        message: 'Erro ao alterar endereço!',
        variant: 'error',
      })
    }
  }

  return (
    <Container>
      <ContentHeader title="Cliente" subtitle="Editar endereço" />
      {isLoading ? (
        <Paper>
          <Box p={2}></Box>
        </Paper>
      ) : (
        <ClientAddressForm
          clientId={clientId}
          address={response.data.customer.address}
          onSubmit={handleSubmit}
        />
      )}
    </Container>
  )
}

export default ClientsEditAddress
